export default __webpack_public_path__ + "static/media/eco_web_bg_mobile.5df23e78.mp4";